<template>
  <div>
    <div>
        <el-select v-model="type" placeholder="请选择获取类型">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
    </div>
    <el-table :data="datas" style="width: 100%" v-loading = "loading" show-summary max-height="600">
      <el-table-column label="获取类型" prop="detailType" width="100"></el-table-column>
      <el-table-column label="详细" prop="details" width="700"></el-table-column>
      <el-table-column label="所属学习班" prop="studyClassTitle" ></el-table-column>
      <el-table-column label="获取学时时间" prop="time"></el-table-column>
      <el-table-column label="获取的学时数" prop="credithour"></el-table-column>
    </el-table>
    <el-pagination
      class="mt-2"
      background
      :page-sizes="[20, 50, 100, 400]"
      layout="sizes,prev, pager, next"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="page_size"
    ></el-pagination>
  </div>
</template>



<script>

import {getClassHoursDetailCurrentApi,getClassHoursDetailOverApi} from '@/api/module/classHours/classHours'

export default {
  name: "hour-detail-current-year",
  props:{
    dataType:{
      type: Number
    } // datatype: 0 今年，1历年
  },
  data() {
    return {
      datas  : [],
      loading : false,
      type  : 0,
      options :  [
        {
          "label": "标准",
          "value": 0
        },
        {
          "label": "补充",
          "value": 1
        },
        {
          "label": "原系统",
          "value": 2
        }
      ],
      currentPage : 1,
      page_size : 50,
      total : 0,

    }
  },
  methods:{
    init(){

      if(this.loading){
        return;
      }

      this.loading = true;

      console.log("init current")    

      let start = (this.currentPage - 1) * this.page_size;


      let data = {
        "uid" : this.uid,
        "type": this.type,
        "start" : start,
        "size": this.page_size
      }

      if(this.dataType == 0){
        getClassHoursDetailCurrentApi(data)
          .then((r)=>{
            let total = r.total;
            let datas = r.records;

            console.log("r",r);

            this.datas = datas;
            this.total = total;
          })
          .finally(()=>{
            this.loading = false;
          })
      }

      if(this.dataType == 1){
        getClassHoursDetailOverApi(data)
          .then((r)=>{
            let total = r.total;
            let datas = r.records;

            console.log("r",r);

            this.datas = datas;
            this.total = total;
          })
          .finally(()=>{
            this.loading = false;
          })
      }

    },

      // 分页
    handleSizeChange(p) {
      this.page_size = p;
    },

    handleCurrentChange(p) {
      this.currentPage = p;
    }
  },

  watch:{
    page_size(){
      this.init()
    },
    currentPage(){
      this.init()
    },
    type(){
      this.currentPage = 1;
      this.init();
    }
  },

  created(){
    this.uid = this.$route.query.id;
    this.init();
  }
}


</script>



<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>